/**
 * Helper per gestire in modo sicuro i form Contact Form 7 (CF7) che arrivano
 * "annegati" dentro l'HTML renderizzato da WordPress headless.
 *
 * WordPress genera il markup CF7 con un `action` che punta al permalink WP
 * (es. `action="/wp-json/...#wpcf7-f2103-o1"`), esponendo dettagli del backend
 * e puntando a un endpoint che in headless non gestisce il submit.
 *
 * Questa funzione riscrive l'`action` verso il nostro proxy interno
 * (`/api/cf7/{formId}`), così l'URL di WordPress non finisce mai nel sorgente
 * della pagina e il submit passa dal nostro server (vedi `api.cf7.$formId.ts`).
 *
 * È una funzione PURA (nessuna dipendenza server-only): può girare sia nel
 * loader Remix (SSR) sia nel bundle client, così l'HTML è già "sicuro" anche
 * nel sorgente renderizzato lato server.
 */

// L'`action` di un form CF7 termina sempre con l'anchor `#wpcf7-f{ID}-o{N}`,
// che codifica l'id del form. Lo usiamo per ricavare l'id senza dover fare
// parsing del DOM.
const CF7_ACTION_RE = /action="[^"]*(#wpcf7-f(\d+)-o\d+)"/gi;

/**
 * Riscrive l'`action` di tutti i form CF7 presenti nell'HTML verso il proxy
 * interno `/api/cf7/{formId}`, preservando l'anchor originale.
 */
export function rewriteCf7FormActions(html: string): string {
  if (!html || html.indexOf("#wpcf7-f") === -1) return html;
  return html.replace(
    CF7_ACTION_RE,
    (_match, anchor: string, id: string) => `action="/api/cf7/${id}${anchor}"`
  );
}
